import classNames from 'classnames';
import { forwardRef } from 'react';
import { LockingRuleSwitch } from '../..';
import { NameAndColorFields } from '../../name_and_color_fields';
const containerCss = "c1vwnnkz";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const NameAndColorHeader = ({
  lockingRuleName,
  isMETParent,
  isLocked
}) => <Container>
    <NameAndColorFields isLocked={isLocked} />
    {isMETParent && <LockingRuleSwitch ruleName={lockingRuleName} />}
  </Container>;

require("./name_and_color_header.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./name_and_color_header.js");